
import CodeLogin from "@/components/login/codeLogin";

export default {
    name: "Login",
    data(){
        return{
            tabActive: 'account'
        }
    },
    methods:{
        loginTypeChange(type){
            this.tabActive = type;
        },
        /**
         * 关闭登录
         * */
        close() {
            this.$store.commit('LOGIN_ALERT', false);
        }
    },
    components:{
        CodeLogin,
    }
}
